import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import Loader from "../../animation/Loader.json";
import { AuthWrapper } from "../../AuthWrapper";
import { fetchApi } from "../../utlis/axios";
import { FaSearch } from "react-icons/fa";
import Pagination from "../../ListingPage/Pagination";
import RegisterMedicalStore from "../../RegistrationForms/RegisterMedicalStore";

export const MedicalStaff = () => {
  const [storeData, setStoreData] = useState([]);
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedToggle, setSelectedToggle] = useState("in-review");
  const [isLoading, setIsLoading] = useState(null);
  const [isOpen, setIsOpen]=useState(false)

  const navigate = useNavigate();

  const getStoreData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(
        `medical-store/?search=${searchQuery}&status=${selectedToggle}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );
      if (result.status === 200) {
        setStoreData(result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  useEffect(() => {
    getStoreData();
  }, [searchQuery, access, selectedToggle]);

  const handleTableRowClick = (id) => {
    navigate(`/medicalstoredetail/${id}`);
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(storeData.count / itemsPerPage);

  const fetchDataForPage = async (pageNumber) => {
    const newOffset = (pageNumber - 1) * itemsPerPage;

    try {
      const result = await fetchApi.get(
        `medical-store/?limit=${itemsPerPage}&offset=${newOffset}&page=${pageNumber}&pageSize=${itemsPerPage}&search=${searchQuery}&status=${selectedToggle}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );

      return result;
    } catch (error) {
      throw error;
    }
  };

  const handlePageClick = (pageNumber) => {
    console.log("pageNumbber", pageNumber);
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      setIsLoading(true);

      fetchDataForPage(pageNumber)
        .then((result) => {
          if (result.status === 200) {
            setStoreData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };


  const handleToggleClick = (toggleName) => {
    setSelectedToggle(toggleName);
  };

  

  return (
    <AuthWrapper>
      <div className="w-full px-[16px] md:px-10 min-h-screen mt-20 max-w-screen-xl mx-auto">
        {/* Top Section */}
        <h1 className="md:text-4xl text-2xl font-bold capitalize mb-4">
          Medical Stores
        </h1>
        
        {/* Header Section with Search and Button */}
        <div className="flex items-center justify-between gap-3 mt-6 md:mb-8 mb-3">
          {/* Search */}
          <div className="relative flex justify-center border rounded-full sm:py-2 py-[4px] px-2 sm:w-[400px] w-full bg-[#FFFFFF] items-center gap-2">
            <FaSearch className="text-gray-500" />
            <input
              type="search"
              name="search"
              className="w-full outline-none text-gray-600 py-1 px-1"
              placeholder="Search here...."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Register Button */}
          <div className="Tbtn">
            <span
              className="primary-button sm:text-base text-sm font-medium"
              onClick={() => setIsOpen(true)}
            >
              Register Medical Store
            </span>
          </div>
        </div>


        {/* Table Section */}
        <div className="overflow-x-auto bg-white rounded-[20px] border border-gray-border">
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="bg-primary-green text-white text-left">
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Pharmacy
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Manager
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Email
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Phone Number
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Address
                </th>
              
              </tr>
            </thead>

            <tbody className="">
              {isLoading ? (
                <tr>
                  <td colSpan={8} className="h-[60vh]">
                    <div className="flex justify-center items-center h-full w-full">
                      <Lottie
                        loop={true}
                        animationData={Loader}
                        style={{ width: "200px" }}
                        className="auth-sidebar-video"
                      />
                    </div>
                  </td>
                </tr>
              ) : storeData?.results?.length > 0 ? (
                storeData?.results?.map((data, index) => (
                  <tr
                    key={index}
                    className={`cursor-pointer ${
                      index % 2 === 0 ? "bg-white" : "bg-[#0EA5A414]"
                    } hover:bg-gray-200`}
                    onClick={() => handleTableRowClick(data?.id)}
                  >
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      <span className="font-semibold text-gray-800">
                        {data?.name}
                      </span>
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      {data?.user?.first_name} {data?.user?.last_name}
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      <span className="text-gray-600">
                        {data?.user?.email}
                      </span>
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      {data?.phone_number}
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      {data?.address && data.address.length > 30
                        ? `${data.address.slice(0, 30)}...`
                        : data?.address}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="p-4 text-center">
                    No medical stores found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
      <div className="flex justify-center items-center mt-6">
        <Pagination
          currentPage={currentPage}
          handlePageClick={handlePageClick}
          totalPages={totalPages}
        />
      </div>
      </div>
      {
        isOpen && <RegisterMedicalStore setShowModal={setIsOpen}/>
      }
    </AuthWrapper>
  );
};